import React from 'react';
import { ISliderSectionSlider } from '../slider-section';
import { Link } from 'gatsby';
import { Button } from '../../../../components/button/button';
import Slider from '../../../../components/slider/slider';

interface ISliderSectionMobileLayoutProps {
  slides: ISliderSectionSlider[];
  sliderOnMobile?: boolean;
}
export default function SliderSectionMobileLayout({ slides, sliderOnMobile }: ISliderSectionMobileLayoutProps) {
  const slidesList = slides.map((slide, idx) => (
    <Link key={idx} to={slide.info.link} className="slider-section__simple-info-block">
      <div className="slider-section__simple-info-block__info">
        <Button isExtra textContent={slide.info.name} />
        <h3>{slide.info.title}</h3>
      </div>
      <div className="slider-section__simple-info-block__image">
        <img src={slide.image.src} alt={slide.image.alt} />
      </div>
    </Link>
  ));

  return (
    <div className="slider-section__simple-wrapper">{sliderOnMobile ? <Slider slides={slidesList} /> : slidesList}</div>
  );
}
